import * as React from 'react';
import { SVGProps } from 'react';

const UsersIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 14"
    fill="none"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.914 2.586a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828ZM15.768 1.732a2.5 2.5 0 1 1-3.536 3.536 2.5 2.5 0 0 1 3.536-3.536ZM18.5 13v-1a3 3 0 0 0-3-3h-3a3 3 0 0 0-3 3v1M6.5 9h-2a3 3 0 0 0-3 3v1"
    />
  </svg>
);
export default UsersIcon;
